<template>
    <div class="customer-info">
      <div class="customer-info-item" >
        <div class="customer-info-title">
          <!--图标-->
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-qiyexinxi"></use>
          </svg>
          <span>薪酬组信息</span>
        </div>

        <div class="filter-container">
          <el-link type="primary" @click="toEditPage()" style="margin-right:10px;">新增</el-link>
           <el-link type="primary" @click="changeStatus('90110001')" style="margin-right:10px;">启用</el-link>
            <el-link type="primary" @click="changeStatus('90110002')" >禁用</el-link>
        </div>
      </div>
      <div style="height:calc(100vh - 290px);padding:10px 40px;">
 <vxe-table
        auto-resize
        resizable
        export-config
        keep-source
        ref="configCenterTable"
        row-id="id"
        :loading="loading"
        :checkbox-config="{checkStrictly:true ,checkMethod: checCheckboxkMethod2, highlight: true}"
        :tree-config="treeConfig"
        @select-change="selectChange"
        @select-all="selectAll"
        height="auto"
        :edit-config="{trigger: 'click', mode: 'row', showStatus: true}"
        :data.sync="list">
        <vxe-table-column type="checkbox" width="60" ></vxe-table-column>
        <vxe-table-column field="id" title="id" :visible="false"></vxe-table-column>
        <vxe-table-column field="groupName" title="薪酬组名称" tree-node></vxe-table-column>
        <vxe-table-column field="description" title="适用范围"></vxe-table-column>
        <vxe-table-column title="状态" field="status" filter-type="input" width="60">
          <template slot-scope="scope">
            <span>{{scope.row.status | dictFilter(dicts)}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column title="操作" fixed="right" width="150" align="center">
          <template slot-scope="scope">
            <div class="ciic-table-operate">
              <el-button size="small" type="text" @click="toEditPage(scope.row.id)">
                详情
              </el-button>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>

      </div>

   <!-- </bsp-table>-->

  </div>
</template>

<script>
  import BspTable from "@/components/bsp/bsp-table/bsp-table";
  import BspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import {comRequest,getPayGroupList,changeCodeSetStatus,getGroupTree,getCusData} from  "@/api/wage/payGroup";
  import { mapGetters } from 'vuex';
  export default {
    name: 'payGroupList',
    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },
    components: {
      BspTable,
      BspTableColumn,
    },
    created() {
      this._querGroupTree();
      this._getCusData();//获取当前客户数据
    },
    data() {
      return {
        treeConfig: {
          children: 'children',
          expandRowKeys: [],
        },
        loading: false,
        // 弹框状态
        dialogStatus: 'add',
        dialogFormVisible: false,
        infoDialogTitle: "",
        infoDialogVisible: false,
        cusId:0,
        list:[],
        form: {},
        multipleSelection: [],
        options: [{
          codeItemId: '1010001',
          codeItemName: '工资'
        }, {
          codeItemId: '1010002',
          codeItemName: '劳务费'
        }, {
          codeItemId: '1010003',
          codeItemName: '年终奖'
        }],
      }
    },
    methods: {
      _getCusData(){
        getCusData().then((res) => {
          console.log('获取当前客户Id：', res.data.data.cusId);
          this.cusId= res.data.data.cusId;
        });
      },
      //批量更改状态
      selectChange({checked, row}){
        if(checked){
          this.multipleSelection.push(row)
        }
        if(!checked){
          this.multipleSelection.filter((item,index) => {
            if(item===row){
              this.multipleSelection.splice(index,1)
            }
          })
        }
        console.log(this.multipleSelection)
      },
      //复选框全选事件
      selectAll({checked, selection}){
        this.multipleSelection = selection;
        console.log("全选-----",JSON.stringify(this.multipleSelection))
      },
      changeStatus(status){
          let tipStr = "";
          if("90110001"==status){
              tipStr = "启用";
          }else if("90110002"==status){
              tipStr = "禁用";
          }
        let lists = this.$refs.configCenterTable.getCheckboxRecords();

        if(lists.length==0){
          this.$message.error('请选择至少选中一行')
        }else{
          // 分支机构所属薪酬组 支持禁用了
          // if("90110002"==status){
          //   let k = false;
          //   lists.forEach(item => {
          //     if(item.ifBranch=='10020001'){
          //       k = true;
          //     }
          //   },k);
          //   if(k){
          //     this.$message.error('分支机构所属薪酬组无法禁用');
          //     return;
          //   }
          // }

          this.$confirm('是否确认'+tipStr+'？（该操作会影响所有勾选的薪酬组）', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              let param={
                  multipleSelection: lists,
                  status: status
              }
              changeCodeSetStatus(param).then(res =>{
                  if(res.data.code==0){
                      this._querGroupTree();
                      this.$message.success(res.data.msg)
                  }else{
                      this.$message.error(res.data.msg)
                  }
              })
          });
        }
      },
      // 分页查询
      checCheckboxkMethod2({row}){
        console.log("rou============",row)
        if (row.children == null) {
          return true
        } else {
          return false
        }
      },
      _querGroupTree() {
        this.loading=true;
        let o = {};
        getGroupTree(o).then((res) => {
          console.log('153薪酬数列表数据：', res.data.data);
          this.list = res.data.data;
          let defaultExpandKeys = [];
          for(var i=0;i<res.data.data.length;i++){
              defaultExpandKeys.push(res.data.data[i].id);
          }
          this.$set(this.treeConfig,'expandRowKeys',defaultExpandKeys);
          this.loading=false
          // console.log('当前CodeItem分页对象为：'+JSON.stringify(this.list))
        }).catch(err=>{
          this.loading=false
        });
      },

      toEditPage(id) {
        const query = {id:id,cusId:this.cusId};
        this.$router.push({ path: '/wage/payGroupDetail', query});
      },
      saveOrUpdate() {
        if (this.form.id) {
          // 修改
          comRequest("put", this.modelName, this.form).then(res => {
            if (res.data.code === 0) {
              this.infoDialogVisible = false;
              this._getPayGroupList();
            } else {
              this.$message.error("服务器异常");
            }
          });
        } else {
          // 新增
          comRequest("post", this.modelName, this.form).then(res => {
            if (res.data.code === 0) {
              this.infoDialogVisible = false;
              this._querGroupTree();
            } else {
              this.$message.error("服务器异常");
            }
          });
        }
      },
     /* toPayGroupPage(){
        const query = {}
        console.log("编辑参数query=",query);
        this.$router.push({ path: '/wage/payGroupList', query});
      },
      toSalaryTemplatePage(){
        const query = {}
        console.log("编辑参数query=",query);
        this.$router.push({ path: '/wage/salaryList', query});
      },*/
      cancel(){
        this.form = {};
        this.infoDialogVisible = false;
      },

    },
  }
</script>

<style lang="scss">
  #teanant-select{
    width: 100px;
  }

</style>
